import { TranslationKey } from '../../../types/translation/TranslationKey';
import { Grid } from '@mui/material';
import React, { useContext } from 'react';
import { t } from '../../../types/translation/Translator';
import { useNavigate } from 'react-router-dom';
import { CsvUploadConfigurationContext } from '../../../context/CsvUploadConfigurationContext';
import { CsvUploadConfiguration, CsvUploadType } from '../../../types/csvUploadConfiguration';
import BackButton from '../../../VentoryUI/components/common/Button/Templates/BackButton';
import LoadingPackage from '../../pages/Common/LoadingPackage';
import { Card } from '../Card';
import { NoItemsFound } from '../NoItems';
import { IconType } from '../../icons/Icon';

interface CsvUploadConfigurationsScreenProps {
  type: CsvUploadType;
  backPath: string;
}

export default function CsvUploadConfigurationsScreen({ type, backPath }: CsvUploadConfigurationsScreenProps) {
  const navigate = useNavigate();

  const { csvUploadConfigurations, csvUploadConfigurationsLoading } = useContext(CsvUploadConfigurationContext);

  const filteredConfigurations = [...csvUploadConfigurations.values()].filter(e => e.type === type);

  const handleOnClick = (configuration: CsvUploadConfiguration) => {
    navigate(`update/${configuration.id}`);
  };

  const Content = () => {
    if (csvUploadConfigurationsLoading) {
      return (
        <div className='flex h-full items-center justify-center'>
          <LoadingPackage />
        </div>
      );
    }

    if (!filteredConfigurations.length) {
      return (
        <div className='flex h-full flex-col items-center justify-center'>
          <NoItemsFound
            icon={IconType.settings4}
            title={t(TranslationKey.noImportConfigurationsYetTitle).singular.upper}
            subtitle={t(TranslationKey.noImportConfigurationsYetSubtitle).singular.upper}
          />
        </div>
      );
    }

    return (
      <div className='flex flex-wrap gap-4'>
        {filteredConfigurations.map(configuration => (
          <Card key={configuration.id} size='md' onClick={() => handleOnClick(configuration)}>
            <div className='flex flex-col items-center justify-center gap-2'>
              <span className='fiv-viv fiv-icon-conf fiv-size-lg file_icon'></span>
              <p className='select-none text-sm font-semibold'>{configuration.name}</p>
            </div>
          </Card>
        ))}
      </div>
    );
  };

  return (
    <div className={`content-x flex h-full flex-grow flex-col gap-4`}>
      <div className='grid gap-2'>
        <p className='page-title'>{t(TranslationKey.importConfigurationScreenTitle).singular.upper}</p>
        <p className='subtitle'>{t(TranslationKey.importConfigurationScreenSubtitle).singular.upper}</p>
      </div>
      <div className='flex-grow'>
        <Content />
      </div>
      <Grid container justifyContent={'flex-end'}>
        <Grid item>
          <BackButton onClick={() => navigate(backPath)} />
        </Grid>
      </Grid>
    </div>
  );
}
